import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'braidsbook-info-window-title',
  imports: [],
  template: `
    <h4 class="font-semibold text-sm text-wrap truncate">{{ title() }}</h4>
  `,
  styles: ``
})
export class InfoWindowTitleComponent {
  title: InputSignal<string> = input<string>('');
}
